var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLegacyDrag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#fff",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.435 12.222L8 16l-3.454-3.778h6.89zM16 9.333v.89H0v-.89h16zm0-1.777v.888H0v-.888h16zm0-1.778v.889H0v-.89h16zM8 0l3.435 3.778H4.546L8 0z",
    transform: "translate(-1339 -538) translate(735 503) translate(604 35)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLegacyDrag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/legacy-drag.270c321b39d89a725d1603a0ef197776.svg";